import BaseApi from './base.api';

export interface CreateDoctorRequest {
  firstName: string;
  lastName: string;
  speciality: string;
  uinNumber: string;
  phone: string;
  email: string;
  notes?: string;
  degree?: string;
  joiningDate?: string;
  departmentId?: number;
}

export interface UpdateDoctorRequest extends Partial<CreateDoctorRequest> {
  active?: boolean;
}

export interface DoctorResponse {
  id: number;
  firstName: string;
  lastName: string;
  fullName: string;
  speciality: string;
  uinNumber: string;
  phone: string;
  email: string;
  notes?: string;
  degree?: string;
  joiningDate?: string;
  active: boolean;
  createdAt: string;
  updatedAt: string;
  department?: {
    id: number;
    name: string;
    description: string;
    active: boolean;
  };
}

class DoctorApi extends BaseApi {
  async createDoctor(doctor: CreateDoctorRequest): Promise<DoctorResponse> {
    return this.post('/doctors', doctor);
  }

  async updateDoctor(id: number, doctor: UpdateDoctorRequest): Promise<DoctorResponse> {
    return this.put(`/doctors/${id}`, doctor);
  }

  async getAllDoctors(activeOnly: boolean = false): Promise<DoctorResponse[]> {
    return this.get(`/doctors?activeOnly=${activeOnly}`);
  }

  async getDoctorById(id: number): Promise<DoctorResponse> {
    return this.get(`/doctors/${id}`);
  }

  async getDoctorByUin(uinNumber: string): Promise<DoctorResponse> {
    return this.get(`/doctors/uin/${uinNumber}`);
  }

  async getDoctorsByDepartment(departmentId: number): Promise<DoctorResponse[]> {
    return this.get(`/doctors/department/${departmentId}`);
  }

  async searchDoctors(name: string): Promise<DoctorResponse[]> {
    return this.get(`/doctors/search?name=${encodeURIComponent(name)}`);
  }

  async deleteDoctor(id: number): Promise<void> {
    return this.delete(`/doctors/${id}`);
  }

  async permanentlyDeleteDoctor(id: number): Promise<void> {
    return this.delete(`/doctors/${id}/permanent`);
  }
}

export default new DoctorApi();